import { render, staticRenderFns } from "./chatForm.vue?vue&type=template&id=420208be"
import script from "./chatForm.vue?vue&type=script&lang=js"
export * from "./chatForm.vue?vue&type=script&lang=js"
import style0 from "./chatForm.vue?vue&type=style&index=0&id=420208be&prod&lang=scss"
import style1 from "./chatForm.vue?vue&type=style&index=1&id=420208be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports